<template>
  <div class="ws-crud mx-auto">
    <WsBreadCrumbs v-if="isBreadCrumbsShow" :items="_breadcrumbsItems"></WsBreadCrumbs>
    <WsCRUDTitlebar
      v-if="showTitlebar"
      :label="label"
      :pageMode="pageMode"
      :modelName="modelName"
      :isCreatable="isCreatable"
      @create-open="$_onCreateOpen()"
    >
      <template v-slot:btns>
        <slot name="titlebarCustomBtns"/>
        <WsBtn
          v-if="importRoute"
          :to="importRoute"
          minWidth="90px"
          color="textSecondary"
          outlined
        >
          <v-icon size="20">mdi-upload</v-icon>
          <div>匯入</div>
        </WsBtn>
        <WsBtn
          v-if="exportUrl"
          minWidth="100px"
          class="ml-2"
          @click="$_onExport()"
        >匯出</WsBtn>
      </template>
    </WsCRUDTitlebar>
    <v-tabs
      v-if="isVtabsShow"
      class="mt-5"
      background-color="transparent"
      v-model="tab"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="(tab,tabIndex) in tabFields"
        :key="tabIndex"
        :disabled="modeldataLoading"
        @click.stop.prevent="$_switchTabContent(tab.value)"
      > {{tab.text}}
      </v-tab>
    </v-tabs>
    <v-card
      class="mt-6"
      elevation="1"
    >
      <WsCRUDFilter
        v-if="isFilterShow"
        ref="filter"
        hasCloseChips
        :searching.sync="searching"
        :orderBy.sync="C_orderBy"
        :orderWay.sync="C_orderWay"
        :dateSort="dateSort"
        :hasSearchBtn="hasSearchBtn"
        :placeholder="placeholder"
      >
        <template v-slot:filterSelects>
          <v-row>
            <v-col
              v-for="(filterSelect,filterSelectIndex) in filterSelects"
              :key="filterSelectIndex"
              cols="12"
              alignSelf="center"
              :sm="filterSelect.sm ? filterSelect.sm : 3"
            >
              <WsState
                isNoMt
                :value="_filters[(filterSelect.paramName? filterSelect.paramName: filterSelect.modelName)]"
                @input="$_onFilterSelectInput(filterSelect,$event)"
                :type="filterSelect.type"
                :rules="filterSelect.rules"
                :orderWay="filterSelect.orderWay"
                :orderBy="filterSelect.orderBy"
                :placeholder="filterSelect.placeholder"
                :modelName="filterSelect.modelName"
                :requiredField="filterSelect.requiredField"
                :getUrl="filterSelect.getUrl"
                :hasNoSearch="filterSelect.hasNoSearch"
                :items="$_getFilterItems(filterSelect)"
                :hasAllSelectBtn="filterSelect.hasAllSelectBtn"
                :activeText="filterSelect.activeText"
                :inactiveText="filterSelect.inactiveText"
                :conditions="$_getConditions(filterSelect)"
                :originData="_filters"
                :getFromDate="filterSelect.getFromDate"
                :getEndDate="filterSelect.getEndDate"
                :parentState="$_getParentState(filterSelect)"
                :parentStateName="filterSelect.parentStateName"
                :requiredFieldState="$_getParentState(filterSelect)"
                :requiredFieldValue="filterSelect.requiredFieldValue"
                :getText="filterSelect.getText"
                :displayCheck="$_getFieldAttr((filterSelect.paramName? filterSelect.paramName: filterSelect.modelName),'displayCheck')"
              ></WsState>
            </v-col>
          </v-row>
        </template>
        <template v-slot:closeChips>
          <WsChipList
            :chipList="closeChipList"
            :textColor="closeChipTextColor"
            :borderColor="closeChipBorderColor"
            :backgroundColor="closeChipBackgroundColor"
            :title="closeChipTitle"
          ></WsChipList>
        </template>
      </WsCRUDFilter>
      <!-- Data Table -->
      <!-- <v-skeleton-loader
        v-if="modeldataLoading"
        type="table"
      ></v-skeleton-loader> -->
      <WsFlex v-if="isMultiSelect">
        <span class="mr-4">{{_selected.length}} 項已選取</span>
        <slot name="multiSelectCustomBtns" :items="_selected" :modelDatas="modelDatas"/>
        <WsBtn
          v-if="hasMultiDeleteBtn"
          @click="$_onDeleteMulti(_selected)"
          color="deleteBtn white--text"
          class="mx-1"
          :disabled="!_selected.length"
        >
          <v-icon left>mdi-delete</v-icon> 刪除
        </WsBtn>
      </WsFlex>
      <WsDataTable
        ref="WsDataTable"
        :loading="modeldataLoading"
        :inRowBtnComplete="inRowBtnComplete"
        :inRowBtnRead="inRowBtnRead"
        :inRowBtnUpdate="inRowBtnUpdate"
        :inRowBtnDelete="inRowBtnDelete"
        :rowClickRead="rowClickRead"
        :rowClickEmit="rowClickEmit"
        :items="modelDatas"
        :itemsPerPage="itemsPerPage"
        :fields="fields"
        :label="label"
        :displayFields="_displayFields"
        :headers="_tableHeaders"
        :pageMode="pageMode"
        :modelName="modelName"
        :dataTotalCount="dataTotalCount"
        :currentPage="currentPage"
        :lastPage="lastPage"
        :showExpand="showExpand"
        :sortBy="C_orderBy"
        :sortDesc="_sortDesc"
        :isMultiSelect="isMultiSelect"
        :isShowBtn="isShowBtn"
        :tabValue="tabValue"
        :isPaginationShow="isPaginationShow"
        :getCustomReadUrl="getCustomReadUrl"
        :wrapColumns="wrapColumns"
        @read="$_onRead($event)"
        @pageto="$_onPageto($event)"
        @update="$_onUpdate($event)"
        @delete="$_onDelete($event)"
        @complete="$_onComplete($event)"
        @sort-update="$_onSortUpdate($event)"
        :value="_selected"
        @update:selected="$_onSelected($event)"
        @rowClickInput="$_onRowClickInput($event)"
        @row-click-item="$emit('row-click-item',$event)"
      >
        <template v-slot:customBtns="{item}">
          <slot name="customBtns" :item="item" :modelDatas="modelDatas" :tabValue="tabValue"/>
        </template>
      </WsDataTable>
    </v-card>
    <!-- Create Dialog -->
    <WsCreateDialog
      ref="createDialog"
      :label="label"
      :fields="_createFields"
      :modelName="modelName"
      :errorMessages="createErrorMessages"
      @create-submit="$_onCreateSubmit($event)"
    />
    <WsUpdateDialog
      ref="updateDialog"
      :label="label"
      :fields="_updateFields"
      :modelName="modelName"
      :errorMessages="updateErrorMessages"
      @update-submit="$_onUpdateSubmit($event)"
    />
    <!-- Read Dialog -->
    <WsReadDialog
      ref="readDialog"
      :fields="_displayFields"
      :titleKey="titleKey"
      :deletable="inRowBtnDelete"
      :editable="inRowBtnUpdate"
      :showCardActions="inRowBtnDelete || inRowBtnUpdate"
      @delete-submit="$_onReadDialogDeleteSubmit($event)"
      @update="$_onReadDialogUpdate($event)"
    />
    <!-- Delete Dialog -->
    <WsAlertDialog
      ref="deleteDialog"
      title="確定要刪除嗎？"
      :description="`請再三確認，刪除之後${this.label}將一去不復返。`"
      @submit="$_onDeleteSubmit($event)"
    />
    <!-- Complete Dialog -->
    <WsCompleteDialog
      ref="completeDialog"
      title="確定完成嗎？"
      @submit="$_onCompleteSubmit($event)"
    />
    <!-- Delete Multipul Dialog -->
    <WsAlertDialog
      ref="deleteMultiDialog"
      title="確定要刪除嗎？"
      description="刪除後資料將無法回覆"
      @submit="$_onDeleteMultiSubmit($event)"
    />
    <slot 
      name="customDialog"
      :customFields="_customFields"
      :updateFields="_updateFields"
      :displayFields="_displayFields"
      :errorMessages="updateErrorMessages"
      :titleKey="titleKey"
      :modelDatas="modelDatas"
    />
  </div>
</template>

<script>
import S_download from "@/services/api/v1/download";
import locales from "@/locales/zh_tw";
import H_time from "@/helpers/time";

export default {
  data: () => ({
    isMounted: false,
    modeldataLoading: false,
    modelDatas: null,
    lastPage: 1,
    dataTotalCount: 0,
    currentPage: 1,
    searching: "",
    C_orderBy: "updated_at",
    C_orderWay: "desc",
    filters: {},
    tableSelected: [],
    createErrorMessages: null,
    updateErrorMessages: null,
    selected: [],
    breadCrumbsItemName: "",
    tab:null,
    tabValue: null,
  }),
  methods: {
    $_onSortUpdate($event) {
      this.C_orderBy = $event.sortBy[0];
      this.C_orderWay = $event.sortDesc[0] ? "desc" : "asc";
    },
    $_filterSelectsInit() {
      if (!this.filterSelects) {
        return;
      }
      const query = this.$route.query;
      this.filterSelects.forEach((filterSelect) => {
        const key = filterSelect.paramName? filterSelect.paramName : filterSelect.modelName;
        const _value = query[key]
          ? query[key]
          : filterSelect.type === "multiple-layer-select"
          ? []
          : filterSelect.defaultValue
          ? filterSelect.defaultValue
          : null;
        this.$set(this.filters, key, _value);
        this.$emit("filter-select", this.filters);
      });
    },
    $_onPageto(page) {
      this.currentPage = page;
      this.$_routerUpdate();
    },
    $_onReadDialogUpdate(item) {
      const tarModelData = this.modelDatas.find((e) => {
        return e.id == item.id;
      });
      this.$refs.readDialog.close();
      this.$refs.updateDialog.open(tarModelData);
    },
    $_modelDataUpdate(item) {
      const index = this.modelDatas.findIndex((e) => {
        return e.id == item.id;
      });
      if (index >= 0) {
        this.modelDatas.splice(index, 1);
        this.modelDatas.splice(index, 0, item);
      }
    },
    async $_onUpdateSubmit($event) {
      if (this.$refs.updateDialog.dialog) {
        this.$refs.updateDialog.startLoading()
      }
      try {
        const updateData = this.customUpdateAction ? this.customUpdateAction($event) : $event;
        await this.$axios.patch(`/${this.modelName}/${$event.id}`, updateData);
        await this.$_fetchData();
        if (this.$refs.updateDialog.dialog) {
          this.$refs.updateDialog.close()
        }
      } catch (error) {
        if (this.submitErrorHandler) this.submitErrorHandler(error);
        else if (error && error.response) {
          if (error.response.data.message == "data store fail.") {
            alert("新增失敗");
          } else {
            this.updateErrorMessages = this.$_formatErrorMessages(
              error.response.data.message
            );
          }
        } else {
          alert("新增失敗");
        }
      } finally {
        this.$refs.updateDialog.stopLoading();
      }
    },
    $_onUpdate(item) {
      this.updateErrorMessages = null;
      const tarModelData = this.modelDatas.find((e) => {
        return e.id == item.id;
      });
      this.$refs.updateDialog.open(tarModelData);
    },
    $_removeModeldataById(id) {
      const index = this.modelDatas.findIndex((e) => {
        return e.id == id;
      });
      if (index >= 0) {
        this.modelDatas.splice(index, 1);
      }
    },
    async $_onDeleteSubmit($event) {
      this.$refs.deleteDialog.startLoading();
      try {
        await this.$axios.delete(`/${this.modelName}/${$event}`);
        this.$_removeModeldataById($event);
      } catch (error) {
        alert(error);
      } finally {
        this.$refs.deleteDialog.close();
      }
    },
    async $_onCompleteSubmit($event) {
      this.$refs.completeDialog.startLoading();
      try {
        await this.$axios.post(`/${this.modelName}/complete/${$event}`);
        this.$refs.completeDialog.close();
        this.$_fetchData();
      } catch (error) {
        alert(error);
      } finally {
        this.$refs.completeDialog.close();
      }
    },
    $_onComplete($event) {
      this.$refs.completeDialog.open($event.id);
    },
    $_onDelete($event) {
      this.$refs.deleteDialog.open($event.id);
    },
    $_onDeleteMulti($event) {
      if (!$event.length) return;
      this.$refs.deleteMultiDialog.open($event);
    },
    $_onDeleteMultiSubmit($event) {
      this.$refs.deleteMultiDialog.startLoading();
      $event.forEach((item) => {
        this.$_onDeleteSubmit(item.id);
        this.selected = [];
        this.$refs.deleteMultiDialog.close();
      });
    },
    $_formatErrorMessages(errorMessages) {
      const formeted_error_messages = {};
      for (let key in errorMessages) {
        const errorMessage = errorMessages[key][0];
        if (locales[errorMessage]) {
          formeted_error_messages[key] = locales[errorMessage];
        } else {
          formeted_error_messages[key] = errorMessage;
        }
      }
      return formeted_error_messages;
    },
    async $_onCreateSubmit($event) {
      this.$refs.createDialog.startLoading();
      try {
        if (this.customCreateAction) $event = this.customCreateAction($event);
        const res = await this.$axios.post(`/${this.modelName}`, $event);
        this.modelDatas.unshift(res.data.data);
        this.$refs.createDialog.close();
      } catch (error) {
        if (error && error.response) {
          if (error.response.data.message == "data store fail.") {
            alert("新增失敗");
          } else {
            this.createErrorMessages = this.$_formatErrorMessages(
              error.response.data.message
            );
          }
        } else {
          alert("新增失敗");
        }
      } finally {
        this.$refs.createDialog.stopLoading();
      }
    },
    $_onCreateOpen() {
      this.createErrorMessages = null;
      this.$refs.createDialog.open();
    },
    async $_onReadDialogDeleteSubmit($event) {
      this.$refs.readDialog.deleteLoadingStart();
      try {
        await this.$axios.delete(`/${this.modelName}/${$event.id}`);
        this.$_removeModeldataById($event.id);
      } catch (error) {
        alert(error);
      } finally {
        this.$refs.readDialog.close();
      }
    },
    $_onRead($event) {
      if (this.$refs.updateDialog.dialog) {
        this.$refs.updateDialog.close()
      }
      const tarModelData = this.modelDatas.find((e) => {
        return e.id == $event.id;
      });
      this.$refs.readDialog.open(tarModelData);
    },
    async $_fetchData() {
      this.modelDatas = [];
      setTimeout(async () => {
        this.modeldataLoading = true;
        this.$store.dispatch("app/startPageLoading");
        this.$store.dispatch("locale/changeLanguageAble");
        try {
          let params = {
            page: this.currentPage,
            search: this.searching,
            order_way: this.C_orderWay,
            order_by: this.C_orderBy,
            lang: this.$store.state.locale.selectingLocale,
            ...this.customUrlParams,
          };
          if (this.getParams) {
            params = {...params, ...this.getParams(this.id)}
          }
          for (let fieldKey in this._filters) {
            const selectField = this.filterSelects.find(
              (filter) => {
                let key = filter.paramName? filter.paramName : filter.modelName
                return key === fieldKey}
            );
            const paramKey = selectField.paramName
              ? selectField.paramName
              : fieldKey;
            if (
              selectField.type === "hasMany" ||
              selectField.type === "multiple-layer-select"
            ) {
              if (this._filters[fieldKey]) {
                params[paramKey] = this._filters[fieldKey].join(",");
              } else {
                params[paramKey] = [];
              }
            } else if (
              selectField.type === "dateDuration" &&
              this._filters[fieldKey] &&
              this._filters[fieldKey].start &&
              this._filters[fieldKey].end
            ) {
              const {start, end} = this._filters[fieldKey];
              const start_time = H_time.getDateDashFormat(H_time.setTimeToUtc(start));
              const end_time = H_time.getDateDashFormat(H_time.setTimeToUtc(H_time.endOf(end, "YYYY-MM-DD HH:mm:ss")));
              params = {
                ...params,
                start_time,
                end_time,
                time_field: selectField.timeField ? selectField.timeField : "updated_at",
              }
            } else {
              params[paramKey] = this._filters[fieldKey];
            }
          }
          if (this.customParams) {
            for (let item in this.customParams) {
              params[item] = this.customParams[item];
            }
          }
          const res = await this.$axios.get(this._fetchUrl, {
            params: params,
          });
          if (this.isBreadCrumbsShow) {
            if (this.isFetchBreadCrumbsName) {
              const {data} = await this.$axios.get(`/${this.modelName}/${this.$route.params.id}`)
              this.breadCrumbsItemName = data.data.name
            } else {
              this.breadCrumbsItemName = res.data.data.name
            }
          }
          if (res.data.meta) {
            this.lastPage = res.data.meta.last_page;
            this.dataTotalCount = res.data.meta.total;
          }
          if (Array.isArray(res.data.data)) {
            this.modelDatas = res.data.data;
          } else {
            this.modelDatas = [res.data.data]
          }
          this.$emit('set-modelDatas', this.modelDatas)
        } catch (error) {
          alert(error);
        } finally {
          this.modeldataLoading = false;
          this.$store.dispatch("app/stopPageLoading");
        }
      }, 0);
    },
    $_dataInitFrompProps() {
      this.C_orderWay = this.orderWay;
      this.C_orderBy = this.orderBy;
    },
    $_dataInitFromQuery() {
      if (this._searchFromQuery) {
        this.searching = this._searchFromQuery;
      }
      if (this._pageFromQuery) {
        this.currentPage = this._pageFromQuery;
      }
      if (this._orderWayFromQuery) {
        this.C_orderWay = this._orderWayFromQuery;
      }
      if (this._orderByFromQuery) {
        this.C_orderBy = this._orderByFromQuery;
      }
    },
    $_routerUpdate() {
      if (
        (this._pageFromQuery == this.currentPage &&
          this._orderByFromQuery == this.C_orderBy &&
          this._orderWayFromQuery == this.C_orderWay &&
          this._searchFromQuery == this.searching) ||
        this.noChangePage
      ) {
        return;
      }
      setTimeout(() => {
        this.$router.push({
          query: {
            ...this.$route.query,
            order_by: this.C_orderBy,
            order_way: this.C_orderWay,
            page: this.currentPage,
            search: this.searching,
          },
        });
      }, 0);
    },
    $_dataWatch() {
      this.$watch(
        (vm) =>
          [vm.C_orderBy, vm.C_orderWay, vm.currentPage].join(),
        () => {
          if (!this.isMounted) {
            return;
          }
          this.$_fetchData();
          this.$_routerUpdate();
        }
      );
    },
    $_getConditions(field) {
      const conditions = field.conditionKeys;
      if (!conditions) return;
      const _conditions = [];
      conditions.forEach((conditionKey) => {
        _conditions.push({
          key: conditionKey.conditionName,
          value: this._filters[conditionKey.fieldName],
          type: conditionKey.type,
        });
      });
      return _conditions;
    },
    $_getParentState(field) {
      if (field.parentKey) {
        return this._filters[field.parentKey];
      } else if (field.requiredField) {
        return this._filters[field.requiredField];
      } else {
        return null;
      }
    },
    $_getFieldAttr(fieldKey, keyName) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, this._updateFields);
      if (field === null) return
      return field[keyName];
    },
    $_onSelected($event) {
      this.selected = $event;
      this.$emit("input", this.selected);
    },
    $_onRowClickInput($event) {
      this.$emit("rowClickInput", $event);
    },
    $_onFilterSelectInput(filterSelect, $event) {
      let key = ""
      if (filterSelect.paramName !== undefined) {
        key = filterSelect.paramName
      } else {
        key = filterSelect.modelName
      }
      this.filters = {
        ...this.filters,
        [key]: $event
      };
      this.$_updateQuery(key, $event);
      this.$emit("filter-select", this.filters);
    },
    $_switchTabContent(value){
      if (this.modeldataLoading) return;
      this.tabValue = value
      this.$emit('tab-switched', value)
      this.$_fetchData()
    },
    $_setTabValue(value){
      if (!value) return
      this.tabValue = value
    },
    $_getFilterItems(filterSelect) {
      return filterSelect.getItems
        ? filterSelect.getItems()
        : filterSelect.items;
    },
    async $_onExport() {
      if (!this.exportUrl) return;
      try {
        S_download.xlsxDownload({ url: this.exportUrl, fileName: this.label });
      } catch (error) {
        alert(error);
      }
    },
    $_updateQuery(key, value) {
      if (!key || typeof key !== 'string') return;

      const currentQuery = { ...this.$route.query };

      if (value === null || value === undefined || value === '') {
        if (currentQuery[key] !== undefined) {
          delete currentQuery[key];
        }
      } else {
        if (currentQuery[key] !== value) {
          currentQuery[key] = value;
        } else {
          return;
        }
      }

      if (this.$_CMS_isDeepEqual(currentQuery, this.$route.query)) {
        return;
      }

      this.$router.replace({
        query: currentQuery,
      });
    },
  },
  computed: {
    _sortDesc() {
      if (this.C_orderWay == "desc") {
        return true;
      } else {
        return false;
      }
    },
    _createFields() {
      return this.$_CMS_geUpdateFields(this.fields, this.createHideFields);
    },
    _updateFields() {
      return this.$_CMS_geUpdateFields(this.fields, this.updateHideFields);
    },
    _displayFields() {
      return this.$_CMS_getDisplayFields(this.fields, this.displayHideFields);
    },
    _customFields(){
      return this.$_CMS_getDisplayFields(this.fields, this.customHideFields);
    },
    _tableHeaders() {
      let _tableHeaders = [];
      this.showFields.forEach((showFieldKey) => {
          const field = this.fields[showFieldKey];
          if (!field) return
          if (field.type == "list" || field.type == "evaluationStage") {
            return;
          }
          if (
            field.type == "image" ||
            field.type == "tags" ||
            field.type == "password" ||
            field.type == "link" ||
            field.type == "hasMany" ||
            field.type == "custom" ||
            field.type == "locale" ||
            field.type == "editor"
          ) {
            _tableHeaders.push({
              value: showFieldKey,
              text: field.label,
              width: field.width,
              sortable: false,
            });
            return;
          }

          _tableHeaders.push({
            value: showFieldKey,
            text: field.label,
            width: field.width,
            // sortable: false,
          });
      });
      let actionWidth = 32;
      let count = 0;
      if (this.inRowBtnRead) {
        actionWidth += 40.1;
        count++;
      }
      if (this.inRowBtnUpdate) {
        actionWidth += 40.1;
        count++;
      }
      if (this.inRowBtnDelete) {
        actionWidth += 40.1;
        count++;
      }
      if (this.inRowBtnComplete) {
        actionWidth += 40.1;
        count++;
      }
      actionWidth += count * 8;
      _tableHeaders.push({
        text: "",
        value: "actions",
        width: `${actionWidth}px`,
        sortable: false,
        fixed: true,
      });
      return _tableHeaders;
    },
    _pageFromQuery() {
      return this.$route.query.page;
    },
    _orderByFromQuery() {
      return this.$route.query.order_by;
    },
    _orderWayFromQuery() {
      return this.$route.query.order_way;
    },
    _searchFromQuery() {
      return this.$route.query.search ? this.$route.query.search : "";
    },
    _orderValue() {
      return `order_by=${this.C_orderBy}&order_way=${this.C_orderWay}`;
    },
    _selected() {
      if (this.value) {
        return this.value;
      } else {
        return this.selected;
      }
    },
    _filters() {
      if (this.filterProps) {
        return this.filterProps;
      } else {
        return this.filters;
      }
    },
    // _description() {
    //   return `請再三確認，刪除之後${this.label}將一去不復返。`;
    // },
    _breadcrumbsItems() {
      if (this.customBreadcrumbsItems) return this.customBreadcrumbsItems;
      const _breadcrumbsItems = []
      _breadcrumbsItems.push({
        text: this.subLabel,
        to: `/${this.modelName}`,
        disabled: false,
      });
      _breadcrumbsItems.push({
        text: this.breadCrumbsItemName,
        to: `/${this.modelName}/${this.id}`,
        disabled: false,
      });

      _breadcrumbsItems.push({
        text: this.label,
        disabled: true,
      })
    return _breadcrumbsItems;
    },
    _fetchUrl(){
      let url = ''
      if (this.getUrl) {
        url = this.getUrl(this.id, this.tabValue)
      } else {
        url = this.tabValue? `/${this.tabValue}` : `/${this.modelName}`
      }
      return url
    }
  },
  watch: {
    "$store.state.locale.selectingLocale": {
      handler() {
        this.$_fetchData();
      },
    },
    _filters: {
      handler() {
        if (!this.isMounted) {
          return;
        }
        this.currentPage = 1;
        this.$_fetchData();
      },
      deep: true,
    },
    _orderValue: {
      handler() {
        if (!this.isMounted) {
          return;
        }
        this.currentPage = 1;
      },
    },
    searching: {
      handler(newVal, oldVal) {
        if (newVal === oldVal) return;
        if (!this.isMounted) {
          return;
        }
        this.currentPage = 1;
        this.$_fetchData();
        this.$_routerUpdate();
      },
    },
    _pageFromQuery: {
      handler() {
        if (this._pageFromQuery) {
          this.currentPage = this._pageFromQuery;
        }
      },
    },
    _orderByFromQuery: {
      handler() {
        if (this._orderByFromQuery) {
          this.C_orderBy = this._orderByFromQuery;
        }
      },
    },
    _orderWayFromQuery: {
      handler() {
        if (this._orderWayFromQuery) {
          this.C_orderWay = this._orderWayFromQuery;
        }
      },
    },
    _searchFromQuery: {
      handler() {
        if (this._searchFromQuery) {
          this.searching = this._searchFromQuery;
        }
      },
    },
    customParams: {
      handler() {
        if (!this.customParams) return;
        this.$_fetchData();
      },
    },
    filterProps: {
      handler() {
        this.filters = this.filterProps;
      },
    },
    _selected: {
      handler() {
        this.$emit("selected-changed", this._selected);
      },
    },
  },
  mounted() {
    this.$_dataInitFrompProps();
    this.$_dataInitFromQuery();
    this.$_filterSelectsInit();
    this.$_setTabValue(this.preTabValue)
    this.$_fetchData();
    setTimeout(() => {
      this.isMounted = true;
      this.$_dataWatch();
    }, 0);
  },
  props: {
    inRowBtnComplete: {
      type: Boolean,
      default: false,
    },
    displayHideFields: {
      type: Array,
      default: null,
    },
    createHideFields: {
      type: Array,
      default: null,
    },
    updateHideFields: {
      type: Array,
      default: null,
    },
    customHideFields: {
      type: Array,
      default: null,
    },
    rowClickRead: {
      type: Boolean,
      default: false,
    },
    rowClickEmit: {
      type: Boolean,
      default: false,
    },
    filterSelects: {
      type: Array,
      default: null,
    },
    itemsPerPage: {
      type: Number,
      default: 15,
    },
    showExpand: {
      type: Boolean,
      default: true,
    },
    importRoute: {
      type: String,
      default: null,
    },
    pageMode: {
      type: Boolean,
      default: false,
    },
    titleKey: {
      type: String,
      default: "name",
    },
    showFields: {
      type: Array,
      required: true,
    },
    inRowBtnRead: {
      type: Boolean,
      default: true,
    },
    inRowBtnUpdate: {
      type: Boolean,
      default: true,
    },
    inRowBtnDelete: {
      type: Boolean,
      default: true,
    },
    orderBy: {
      type: [String, Array],
      default: "updated_at",
    },
    orderWay: {
      type: [String, Array],
      default: "desc",
    },
    liveSearching: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Object,
      required: true,
    },
    modelName: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    subLabel: {
      type: String,
      default: null,
    },
    hasCloseChips: {
      type: Boolean,
      default: false,
    },
    closeChipList: {
      type: Array,
      default() {
        return [];
      },
    },
    closeChipBackgroundColor: {
      type: String,
      default: "",
    },
    closeChipTextColor: {
      type: String,
      default: "",
    },
    closeChipBorderColor: {
      type: String,
      default: "",
    },
    closeChipTitle: {
      type: String,
      default: "",
    },
    isMultiSelect: {
      type: Boolean,
      default: false,
    },
    isShowBtn: {
      type: Boolean,
      default: true,
    },
    showTitlebar: {
      type: Boolean,
      default: true,
    },
    isCreatable: {
      type: Boolean,
      default: true,
    },
    dateSort: {
      type: Boolean,
      default: true,
    },
    customParams: {
      type: Object,
    },
    hasSearchBtn: {
      type: Boolean,
      default: true,
    },
    hasMultiDeleteBtn: {
      type: Boolean,
      default: true,
    },
    noChangePage: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
    },
    filterProps: {
      type: Object,
    },
    isBreadCrumbsShow:{
      type: Boolean,
      default: false
    },
    id:{
      type: String,
    },
    isVtabsShow:{
      type: Boolean,
      default: false
    },
    tabFields:{
      type: Array,
      default: null
    },
    preTabValue:{
      type: String,
      default: ""
    },
    customUrlParams:{
      type: Object,
      default: null
    },
    isFilterShow:{
      type: Boolean,
      default: true
    },
    isFetchBreadCrumbsName: {
      type: Boolean,
      default: false,
    },
    getUrl: {
      type: Function,
    },
    getParams: {
      type: Function,
    },
    isPaginationShow:{
      type: Boolean,
      default: true,
    },
    getCustomReadUrl: {
      type: Function,
    },
    customBreadcrumbsItems: {
      type: Array,
    },
    placeholder: {
      type: String,
    },
    customUpdateAction: {
      type: Function,
    },
    exportUrl: {
      type: String,
    },
    customCreateAction: {
      type: Function,
    },
    submitErrorHandler: {
      type: Function,
    },
    wrapColumns: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-crud.scss";
</style>